var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('CrudIndex',{attrs:{"title":"Leave Types","viewColumns":_vm.columns,"fetchUrl":"/leave-types","createUrl":"/leave-types","updateRootUrl":"/leave-types","deleteRootUrl":"/leave-types","createFields":_vm.createFields,"reloadOnSuccess":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }